import {Component, OnInit, Input, NgZone} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {iProductAvailabilitiesEntity, iProductAvailability} from "../../model/ProductAvailabilityModel";
import {ProductAvailabilityService} from "../../services/product-availability.service";
declare const window: any;

@ComponentAsElement('v-product-availability-element')
@Component({
  selector: 'v-product-availability',
  templateUrl: './product-availability.component.html'
})
export class ProductAvailabilityComponent implements OnInit {
  @Input() productCode;
  @Input() asmMode;
  poses: iProductAvailabilitiesEntity[]|null = null;
  storesCities = [];
  showList = false;
  selectedCity = '';
  onlineStore: null|iProductAvailabilitiesEntity = null;

  constructor(
    private productAvailabilityService: ProductAvailabilityService,
    private ngZone: NgZone) { }

  ngOnInit() {
    if (this.productCode) {
      this.getPoses(this.productCode);
    }

    window['angularProductAvailabilityComponentReference'] = {
      component: this,
      zone: this.ngZone,
      changeProductAvailabilityCode: (_productCode) => this.getPoses(_productCode)
    };
  }

  getPoses(_productCode) {
    const productCode = _productCode;
    this.productAvailabilityService.getData(productCode).subscribe((items: iProductAvailability) => {
      this.poses = items.productAvailabilities;

      this.poses.forEach( (pos: iProductAvailabilitiesEntity) => {
        const city = pos.pointOfService.city;

        if (pos.pointOfService.isDeliveryOrigin) {
          this.onlineStore = pos;
        } else if (this.storesCities.indexOf(city) === -1 && typeof city !== 'undefined') {
          this.storesCities.push(city);
        }
      });
    });
  }

  onChangeCity(_city) {
    const city = _city;
    this.showList = false;
    this.selectedCity = city;
    setTimeout(() => this.showList = true, 10);
  }
}
